var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "container p-3 bg-light" },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-6 offset-lg-3 col-12 p-0" }, [
          _c("div", { staticClass: "d-flex justify-content-between" }, [
            _c("div", [
              _c(
                "div",
                [
                  _c("router-link", { attrs: { to: "/job-posts" } }, [
                    _c("img", {
                      attrs: {
                        src: "/static/img/main-logo.svg",
                        alt: "",
                        width: "120"
                      }
                    })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(0)
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c(
                "a",
                {
                  staticClass: "contact-staff btn-outline-secondary",
                  attrs: { href: "#" },
                  on: { click: _vm.openModalContactStaff }
                },
                [
                  _c("i", { staticClass: "fas fa-phone-alt" }),
                  _vm._v(" ติดต่อเจ้าหน้าที่")
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.$route.query.type && _vm.$route.query.type === "saved"
            ? _c("div", { staticClass: "pt-3 pb-2" }, [
                _vm._v("\n        งานที่ฉันสนใจ\n      ")
              ])
            : _c("div", { staticClass: "row py-3 no-gutters mt-4" }, [
                _c("div", { staticClass: "col-lg-4 col-5 pr-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block btn-outline-secondary",
                      on: {
                        click: function($event) {
                          return _vm.loadJobPosts(null)
                        }
                      }
                    },
                    [_vm._v("ดูงานทั้งหมด")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-8 col-7 pl-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block btn-info",
                      on: {
                        click: function($event) {
                          return _vm.displaySearchModal()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fal fa-search" }),
                      _vm._v(" ค้นหางาน\n          ")
                    ]
                  )
                ])
              ]),
          _vm._v(" "),
          _vm.jobPosts && _vm.jobPosts.length > 0
            ? _c(
                "section",
                { staticClass: "text-small" },
                _vm._l(_vm.jobPosts, function(jobPost, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c("job-post-item", {
                        attrs: { jobPost: jobPost },
                        on: { onSelected: _vm.displayJobPostModal }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            : _c("section", [_vm._m(1)]),
          _vm._v(" "),
          _vm.searchParams.page > 0 && _vm.isLoading
            ? _c("div", { staticClass: "p-3 text-center" }, [
                _c("i", { staticClass: "fas fa-spinner fa-pulse" }),
                _vm._v(" กำลังโหลด...\n      ")
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("search-modal", {
        ref: "searchModal",
        on: { searchJobPosts: _vm.loadJobPosts }
      }),
      _vm._v(" "),
      _c("job-post-detail-modal", { ref: "jobPostDetailModal" }),
      _vm._v(" "),
      _c(
        "sweet-modal",
        { ref: "contactStaffModal", attrs: { "overlay-theme": "dark" } },
        [
          _c("section", { staticClass: "main-content bg-light text-left" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 p-0" }, [
                _c("h3", { staticClass: "text-center mt-3 font-weight-bold" }, [
                  _vm._v("บริษัท จัดหางาน บีนีท ฟอร์ บิสซิเนส จำกัด")
                ]),
                _vm._v(" "),
                _c("div", { staticStyle: { padding: "15px" } }, [
                  _c("label", { staticClass: "font-weight-bold" }, [
                    _vm._v("เบอร์ติดต่อ")
                  ]),
                  _vm._v(" "),
                  _c("ul", [
                    _c("li", [
                      _c("i", { staticClass: "fas fa-phone-alt" }),
                      _vm._v(" "),
                      _c("a", { attrs: { href: "tel:+66612742888" } }, [
                        _vm._v("0612742888  คุณพัชร")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("i", { staticClass: "fas fa-phone-alt" }),
                      _vm._v(" "),
                      _c("a", { attrs: { href: "tel:+66632970492" } }, [
                        _vm._v("0632970492 ป๊อก")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("img", {
                      staticClass: "img-fluid",
                      staticStyle: { "max-height": "24px" },
                      attrs: { src: "/static/img/line-logo.png" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "font-weight": "bold" } }, [
                      _vm._v("ไลน์ไอดี")
                    ]),
                    _vm._v(" : "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://line.me/R/ti/p/@jobmaid",
                          target: "_blank"
                        }
                      },
                      [_vm._v("@jobmaid")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-center" }, [
                    _c("img", {
                      staticClass: "img-fluid",
                      staticStyle: { "max-height": "250px" },
                      attrs: {
                        src: "/static/img/recruiting/qr_code_line_jobmaid.png"
                      }
                    })
                  ])
                ])
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "align-self-center pl-3" }, [
      _c("h3", { staticClass: "m-0 text-secondary" }, [
        _vm._v("หางานแม่บ้านประจำ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body text-center" }, [
        _vm._v("ไม่มีข้อมูล")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4152306b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4152306b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobPost/JobPost.vue
// module id = 2339
// module chunks = 0